import type { TIrrigationSchedulerStoreState } from 'App/irrigation-scheduler/utils/store/irrigationSchedulerStore'
import type { TFieldAssetStoreState } from 'stores/fieldAssetStore/fieldAssetStore'
import { checkAuthorization } from 'utils/checkAuthorization'

export const getPermissionForSelectedProperty = (
  fass: TFieldAssetStoreState,
  isss: TIrrigationSchedulerStoreState,
) => {
  const properties = fass.properties
  const selectedPropertyId = isss.selectedPropertyId

  if (!properties || !selectedPropertyId || !properties[Number(selectedPropertyId)]) {
    return {
      edit: false,
      editFertigation: false,
      viewFertigation: false,
      publish: false,
      view: false,
      viewIcsDashboard: false,
    }
  }

  const propertyHasControlProvider = Object.values(
    properties[selectedPropertyId].irrigationZoneEmitters ?? {},
  ).find((irrigationZoneEmitter) => irrigationZoneEmitter.hasControlProvider)

  const hasPublishPermission =
    propertyHasControlProvider &&
    checkAuthorization({
      entity: selectedPropertyId,
      permission: 'PUBLISH_IRRIGATION_PLANNER_EVENTS_TO_CONTROL_PROVIDER',
    })

  return {
    view: checkAuthorization({
      entity: selectedPropertyId,
      permission: 'VIEW_IRRIGATION_PLANNER',
    }),
    edit: checkAuthorization({
      entity: selectedPropertyId,
      permission: 'EDIT_IRRIGATION_PLANNER',
    }),
    viewFertigation: checkAuthorization({
      entity: selectedPropertyId,
      permission: 'VIEW_FERTIGATION',
    }),
    editFertigation: checkAuthorization({
      entity: selectedPropertyId,
      permission: 'EDIT_FERTIGATION',
    }),
    publish: !!hasPublishPermission,
    viewIcsDashboard: checkAuthorization({
      entity: selectedPropertyId,
      permission: 'VIEW_ICS_DASHBOARD',
    }),
  }
}
